import { SET_SHUFFLED_ORDER } from "../action/shuffleAction";

const initialState = {
  shuffledOrder: null,
};

const shuffleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHUFFLED_ORDER:
      return {
        ...state,
        shuffledOrder: action.payload,
      };
    default:
      return state;
  }
};

export default shuffleReducer;
